import accessAuth from "./AuthControl"
import accessDashboard from "./DashboardControl"
import accessPlans from "./PlansControl"
import accessPayments from "./PaymentsControl"
import accessCustomer from "./CustomerControl"

const RoutesMap = {
    ...accessAuth,
    ...accessDashboard,
    ...accessPlans,
    ...accessPayments,
    ...accessCustomer,
}

export default RoutesMap;
